import {
  Node,
  VueNodeViewRenderer,
} from '@tiptap/vue-2';
import LastSeenObjectsShorttag from './LastSeenObjectsShorttag.vue';

export default Node.create({
  name: 'LastSeenObjectsShorttag',
  group: 'block',
  draggable: true,
  atom: true,
  allowGapCursor: true,
  components: {
    ...LastSeenObjectsShorttag.components,
  },
  addAttributes() {
    return {
      ...LastSeenObjectsShorttag.props,
    };
  },
  parseHTML() {
    return [
      {
        tag: 'last-seen-objects-shorttag',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['last-seen-objects-shorttag', HTMLAttributes];
  },
  addNodeView() {
    return VueNodeViewRenderer(LastSeenObjectsShorttag);
  },
});
